import { cx } from './cx';
import type { ShopPaymentMethod } from '@pc/db';

const LABEL: Record<ShopPaymentMethod, string> = {
  credit_card: 'Card',
  crypto_btc: 'BTC',
  crypto_eth: 'ETH',
  crypto_usdt: 'USDT',
  wire: 'Wire',
  ach: 'ACH',
  zelle: 'Zelle',
  cashapp: 'Cash App',
  paypal: 'PayPal',
  check: 'Check',
  other: 'Other',
};

export const PAYMENT_METHODS: ReadonlyArray<{
  value: ShopPaymentMethod;
  label: string;
}> = (Object.entries(LABEL) as Array<[ShopPaymentMethod, string]>).map(
  ([value, label]) => ({ value, label }),
);

export interface PaymentMethodPillsProps {
  methods: ShopPaymentMethod[];
  className?: string;
  /** If true, render a row that wraps; otherwise inline. */
  wrap?: boolean;
}

export function PaymentMethodPills({
  methods,
  className,
  wrap = true,
}: PaymentMethodPillsProps) {
  if (!methods || methods.length === 0) {
    return <span className="text-muted text-sm">No payment methods listed</span>;
  }
  return (
    <ul className={cx('flex gap-1.5', wrap && 'flex-wrap', className)}>
      {methods.map((m) => (
        <li
          key={m}
          className={cx(
            'inline-flex items-center px-2 py-0.5 text-[11px] tracking-wide uppercase',
            'bg-paper-2 text-ink/80 border border-rule',
          )}
        >
          {LABEL[m]}
        </li>
      ))}
    </ul>
  );
}
